
import FaqList from '@/components/FaqList.vue'
import { paginationPage } from '@/utils/paginationSeo'
import CategoryList from '@/components/CategoryList'
import CategoryHub from '@/components/CategoryHub.vue'
import CategoryHubTile from '@/components/CategoryHubTile.vue'
import CategoryListItem from '@/components/CategoryListItem'
import ProductList from '@/components/ProductList'

export default {
  name: 'Category',
  components: {
    CategoryHub,
    CategoryHubTile,
    CategoryList,
    CategoryListItem,
    ProductList,
    ProductSliderList: () => import('@/components/ProductSliderList'),
    FaqList,
  },
  props: {
    category: Object,
    siblingCategories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      seoOpen: false,
      seoFoldable: true,
    }
  },
  fetch() {
    const requestedPage = this.$route.query.page

    if (
      this.categoriesSorted.length > 0 &&
      requestedPage !== undefined &&
      String(requestedPage) !== '1'
    ) {
      this.$404Error()
    }
  },
  computed: {
    hubVariant() {
      return Number(this.category.count_parents_recursive) > 0 ? 'C' : 'B'
    },
    bottomDescription() {
      return (this.category.description_bottom || '').replace(
        /<p[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi,
        ''
      )
    },
    useHub() {
      return this.categoriesSorted.length > 0
    },
    isPaginated() {
      return paginationPage(this.$route.query) !== null
    },
    urlToAdminPage() {
      return `${this.$config.adminUrl}/categories/${this.category.id}`
    },
    categoriesSorted() {
      return [
        ...(this.category.children || []),
        ...(this.category.links || [])
          .filter(item => item.category_b)
          .map(item => ({
            ...item.category_b,
            is_link: true,
            position: item.position,
          })),
      ].sort((a, b) => a.position - b.position)
    },
  },
  mounted() {
    this.$nextTick(() => {
      const body = this.$el.querySelector('#category-bottom-description')
      if (body && body.scrollHeight <= body.clientHeight + 8) {
        this.seoFoldable = false
      }
    })
  },
}
